import React from 'react';

import { ISplitModuleFields } from '@/types/contentful';

import { VariationContainer } from '../VariationContainer';

// Split modules
import { AssetWithText } from './AssetWithText';
import { Form } from './Form';

export function SplitModule({ id, modules }: ISplitModuleFields) {
  return (
    <div
      id={id}
      className="my-16 flex w-full scroll-mt-16 justify-center desktop:my-32 [&>*]:max-w-[1440px] [&>*]:px-3 tablet:[&>*]:px-12"
      data-testid="split-module"
    >
      <div className="-mx-0 flex flex-[1_0_100%] flex-col flex-wrap justify-center tablet:-mx-3 tablet:flex-row [&>*]:px-0 tablet:[&>*]:px-3">
        {modules?.map(({ sys, fields }: any) => (
          <div key={sys?.id} className="column mb-8 w-full tablet:w-1/2">
            {(() => {
              switch (sys?.contentType?.sys?.id) {
                case 'splitAssetWithText':
                  return <AssetWithText {...fields} />;

                case 'splitForm':
                  return <Form {...fields} />;

                case 'variationContainer':
                  return <VariationContainer {...fields} sysId={sys?.id} />;

                default:
                  return null;
              }
            })()}
          </div>
        ))}
      </div>
    </div>
  );
}
